export const IconName = {
  ADD_CIRCLE: 'add-circle',
  CLOSE: 'close',
} as const;
export type IconName = (typeof IconName)[keyof typeof IconName];

// Sizes replicating the Icon component's Size variant in Figma. The px value
// for each is mapped in icon.vue.
export const IconSize = {
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
} as const;
export type IconSize = (typeof IconSize)[keyof typeof IconSize];
